import { z } from 'zod';
import { assetSchema } from '@/types/asset';

export enum TaskState {
  NotStarted = 'notStarted',
  InProgress = 'inProgress',
  WaitingForVersion = 'waitingForVersion',
  Finished = 'finished',
  Cancelled = 'cancelled',
  Errored = 'errored',
}

const uploadAssetSchema = assetSchema.extend({
  folderPath: z.string().optional(),
  size: z.number(),
  path: z.string().optional(),
});

export type UploadAsset = z.infer<typeof uploadAssetSchema>;

export const getUploadsSchema = z.array(uploadAssetSchema);

export type getUploads = z.infer<typeof getUploadsSchema>;

export const uploadStatusSchema = z.enum([
  'ready',
  'uploading',
  'success',
  'error',
  'no-files',
  'no-folder',
  'failed',
  'cancelled',
]);

export const uploadActionMap: Record<TaskState, string> = {
  [TaskState.NotStarted]: 'Pending',
  [TaskState.InProgress]: 'Uploading',
  [TaskState.WaitingForVersion]: 'Waiting for version',
  [TaskState.Finished]: 'Upload Completed',
  [TaskState.Cancelled]: 'Cancelled',
  [TaskState.Errored]: 'Error',
};

export type UploadStatus = z.infer<typeof uploadStatusSchema>;

export const UploadFinishingPercentage = 99;
export const UploadFinishedPercentage = 100;
